// Fehler in der App an den eigenen Server melden, der sie an GlitchTip
// weitergibt (server/src/fehlerwache.ts). Bewusst ohne Sentry-Baustein:
// Gemeldet wird nur Art, Meldung, Stelle im Code und die Seite – keine
// Eingaben, keine Kundendaten (O3). Dieselbe Meldung höchstens einmal je
// Minute; ohne Verbindung geht sie verloren (draußen im Keller ist das so).
//
// Seit dem Gutachten vom 3.11.2026 (Befund 4): Vom Stapel gehen nur die
// Stellen im Code hinaus (Kern, nurStellenImCode) – in Chrome beginnt er mit
// der Meldung, auch über mehrere Zeilen. Die Meldung selbst geht mit, wie sie
// ist: Die Apps bauen sie ohne Kundendaten (der Sender nur aus Art, Status und
// Grund), und wo ein Fehler Kundendaten tragen kann, ersetzt die Stelle sie
// durch festen Text (ablaufFehlerFuerWache, pdfFehlerFuerWache im CRM). Eine
// feste Meldung für jeden Fehler machte die Wache blind; ein Filter, der
// Namen und Adressen in beliebigem Text erkennt, verspräche mehr, als er hält.

import { nurStellenImCode, type AppName } from "@happy-energy/kern";

const zuletzt = new Map<string, number>();

export function fehlerMelden(app: AppName, fehler: unknown): void {
  const f = fehler instanceof Error ? fehler : new Error(String(fehler));
  const schluessel = `${f.name}:${f.message}`;
  const jetzt = Date.now();
  if ((zuletzt.get(schluessel) ?? 0) > jetzt - 60_000) return;
  zuletzt.set(schluessel, jetzt);
  const stapel = nurStellenImCode(f.stack, f);
  void fetch("/api/fehler", {
    method: "POST",
    keepalive: true,
    headers: { "content-type": "application/json" },
    body: JSON.stringify({
      app,
      typ: f.name.slice(0, 200),
      meldung: f.message.slice(0, 2000),
      ...(stapel ? { stapel: stapel.slice(0, 20_000) } : {}),
      ort: (window.location.hash || "/").slice(0, 200),
    }),
  }).catch(() => undefined);
}

export function fehlerwacheStarten(app: AppName): void {
  window.addEventListener("error", (e) => fehlerMelden(app, e.error ?? e.message));
  window.addEventListener("unhandledrejection", (e) => fehlerMelden(app, e.reason));
}
